import { User } from '../../user/objects/user';
import { Permission } from '../../permissions/objects/permission';
import { ProfileActionTypes, SET_LOGIN, SET_PERMISSIONS, SET_PREFERENCES, SET_PROFILE, SET_TOKEN_EXPIRES_AT } from './actionTypes';
import { Preferences } from '../objects/preferences';

export const setLogin = (token: string, token_expires_at: string, user: User, permissions: Permission[]): ProfileActionTypes => ({
    type: SET_LOGIN,
    payload: {
        permissions: permissions,
        token: token,
        user: user,
        token_expires_at: token_expires_at
    }
});

export const setPermissions = (permissions: Permission[]): ProfileActionTypes => ({
    type: SET_PERMISSIONS,
    payload: permissions
});

export const setPreferences = (preferences: Preferences[]): ProfileActionTypes => ({
    type: SET_PREFERENCES,
    payload: preferences
});

export const setProfile = (profile: null | User): ProfileActionTypes => ({
    type: SET_PROFILE,
    payload: profile
});

export const setTokenExpiresAt = (token_expires_at: string | null): ProfileActionTypes => ({
    type: SET_TOKEN_EXPIRES_AT,
    payload: token_expires_at
});